import { Injectable } from '@angular/core';
import {RestHttpService} from "@catcore/services/rest-http.service";
import {Restangular} from "ngx-restangular";

@Injectable()
export class ProjectSpeakerPortService extends RestHttpService<any> {

  constructor(service: Restangular) {
    super('project-speaker-ports', service);
  }

  getInputChannels(speakerPort) {
    return this.getAllSubresources(speakerPort.id, 'input-signals');
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/project-speaker-setup/services/project-speaker-port.service.ts